import React, { useContext } from 'react';
import { EntryContext } from '../contexts/entryContext';
import PlayButton from './PlayButton';
import HowToPlayButton from './HowToPlayButton';
import DisplayContent from '../utils/DisplayContent';

const GameCard = ({ revealGame }) => {
    const { game } = useContext(EntryContext);

    return (
        <div>
            <div className='game-card'>
                <img src={revealGame?.slogo?.ref} alt={revealGame?.title} className='game-logo-image' />
            </div>
            <div className='game-logo'>
                <div className='game-buttons'>
                    <DisplayContent note='Play Game Button' isVisible={game?.gameListPlayButton}>
                        <PlayButton
                            name={`play-${revealGame?.name}`}
                            gameId={revealGame?.game_id}
                            tag={revealGame?.tag}
                            revealGame={revealGame}
                            className='game-play-button'
                            asset={game?.gameListPlayButton}
                        />
                    </DisplayContent>

                    <DisplayContent note='How To Play' isVisible={game?.gameListHowToPlayButton?.ref}>
                        <HowToPlayButton gameName={revealGame?.name} className='game-how-to-play-btn' asset={game?.gameListHowToPlayButton} />
                    </DisplayContent>
                </div>
            </div>
        </div>
    );
};

export default GameCard;
